import React from "react";
import { useRecoilValue } from "recoil";
import UserState from "../../recoil/UserState";
import { getCookie } from "../../utils/cookies";
import HeaderGuest from "./HeaderGuest";
import HeaderUser from "./HeaderUser";

type Props = {};

export default function HeaderGeneral({}: Props) {
  const token = getCookie("token");

  if (token) {
    return <HeaderUser />;
  }

  return <HeaderGuest />;
}
